import { Exclude, Expose, Type, Transform } from 'class-transformer';
import moment, { Moment } from 'moment';

export enum PlanType {
  FREE = 'free',
  SHOPLINK = 'shop',
  CUSTOM = 'custom'
}

export enum BillingCycle {
  MONTH = 'month',
  YEAR = 'year'
}

export enum FreePlanName {
  OLD = 'free',
  NEW = 'PERSONAL'
}

@Exclude()
export class PlanDTO {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  billingCycle: BillingCycle;

  @Expose()
  price: number;

  @Expose()
  postLimit: number;

  @Expose()
  memberLimit: number;

  @Expose()
  accountLimit: number;

  @Expose()
  commentLimit: number;

  @Expose()
  period: number;

  @Expose()
  metricsDays: number;

  @Expose()
  analyticsDays: number;

  @Expose()
  type: PlanType;

  @Expose()
  storyLimit: number;

  @Expose()
  uploadsRemain: number;

  @Expose()
  storyUploadsRemain: number;

  @Expose()
  @Type(() => PlanDTO)
  basePlan: PlanDTO;

  @Expose()
  @Transform(({ value }) => (value ? moment.utc(value) : null), { toClassOnly: true })
  expiredAt: Moment;

  @Expose()
  isApple: boolean;

  @Expose()
  setLimit: number;

  get group(): string {
    if (this.basePlan) {
      return this.basePlan.name.replace('YEARLY', '').trim();
    }
    return this.name.replace('YEARLY', '').trim();
  }

  isFree(): boolean {
    return this.type == PlanType.FREE;
  }

  isSolo(): boolean {
    return !this.isFree() && this.accountLimit === 1;
  }

  isAnnual(): boolean {
    return this.billingCycle === BillingCycle.YEAR;
  }

  isCustom(): boolean {
    return this.type === PlanType.CUSTOM;
  }

  get isExpired(): boolean {
    return this.expiredAt < moment().utc();
  }

  isNewPlan() {
    return this.setLimit > 0 || this.name === FreePlanName.NEW;
  }

  isPersonalPlan() {
    return this.name === FreePlanName.NEW;
  }

  isStarterPlan() {
    return this.name.startsWith('STARTER');
  }

  isGrowthPlan() {
    return this.name.startsWith('GROWTH');
  }

  isProfessionalPlan() {
    return this.name.startsWith('PROFESSIONAL');
  }
}
